@if (isLoading | async) {
  <div class="overlay">
    <div class="spinner-border spinner-style" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
}